module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nestle-1-d7fad0551ac512f57608b838ca213737.jpg";